import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import "./App.css";

import NavBar from "./components/NavBar";
import Hero from "./components/Hero";
import AboutUs from "./components/AboutUs";
import StatsStrip from "./components/StatsStrip";
import Fleet from "./components/Fleet";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";

import Impresszum from "./components/Impresszum";
import PrivacyPolicy from "./components/PrivacyPolicy";


// ------------------------------
//   HOME PAGE
// ------------------------------
function HomePage() {


  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const el = document.querySelector(location.state.scrollTo);
      if (el) {
        // Delay slightly to allow rendering
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth' });
        }, 300);
      }
    }
  }, [location.state]);

  return (
    <>
      <Hero />
      <AboutUs />
      <StatsStrip />
      <Fleet />
      <FAQ />
    </>
  );
}


// ------------------------------
//   MAIN APP (with Router)
// ------------------------------
function App() {
  return (
    <Router>
      <div className="App">

        <NavBar />

        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/impresszum" element={<Impresszum />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
        </Routes>

        <CookieBanner />
        <Footer />

      </div>
    </Router>
  );
}

export default App;
